import React, { forwardRef } from "react";
import { cn } from "@/app/utils/cn";

interface SliderProps extends React.InputHTMLAttributes<HTMLInputElement> {
  value: number;
  min: number;
  max: number;
  allowedValues?: number[];
}

const Slider = forwardRef<HTMLInputElement, SliderProps>(
  ({ className, value, min, max, allowedValues, ...props }, ref) => {
    const findClosestAllowedValue = (val: number) => {
      if (!allowedValues || allowedValues.length === 0) return val;

      return allowedValues.reduce((prev, curr) => {
        return Math.abs(curr - val) < Math.abs(prev - val) ? curr : prev;
      });
    };

    const actualValue = allowedValues ? findClosestAllowedValue(value) : value;
    const percentage = ((actualValue - min) / (max - min)) * 100;

    return (
      <div className={cn("relative flex h-6 w-full items-center", className)}>
        <div className="absolute h-2 w-full overflow-hidden rounded-full bg-gray-200">
          <div
            className="h-full bg-primary"
            style={{ width: `${percentage}%` }}
          />
        </div>
        <input
          type="range"
          min={min}
          max={max}
          value={actualValue}
          ref={ref}
          className="absolute z-10 h-full w-full cursor-pointer opacity-0"
          {...props}
        />
        <div
          className="pointer-events-none absolute h-5 w-5 rounded-full border-2 border-primary bg-white shadow"
          style={{ left: `calc(${percentage}% - 10px)` }}
        />
      </div>
    );
  },
);

Slider.displayName = "Slider";

export { Slider };
